import InstitutionsSelect from "../../InstitutionsSelect";

const InstitutionSelectStep = ({ institutionError, onInstitutionSelected }) => (
  <>
    <h2 className="pt-2 pb-4 font-semibold">Select your banking provider</h2>
    <p className="pb-6">
      We will automatically transfer you to your bank to authorise the payment
      via our partner Yapily.
    </p>
    {institutionError && (
      <p className="text-red-500 mb-6 text-sm">
        An error occurred while setting up the payment. If the error continues,
        attempt the refund through your banking application directly.
      </p>
    )}
    <InstitutionsSelect onSelect={onInstitutionSelected} />
  </>
);

export default InstitutionSelectStep;
